<template>
  <div>
    <div class="md-layout pricing-rule">
      <board-select class="md-layout-item md-size-20 md-small-size-50" v-model="value.action.board_ids" multiple> </board-select>
      <span>Than</span>
      <board-select v-model="value.action.source_board_id" class="md-layout-item md-size-20 md-small-size-50"> </board-select>
      <md-field class="md-layout-item md-size-10 md-small-size-50">
        <label>increments</label>
        <md-input v-model.number="value.action.delta"></md-input>
      </md-field>
      <md-radio v-model="value.action.percent" :value="false">{{ currency }}</md-radio>
      <md-radio v-model="value.action.percent" :value="true">%</md-radio>
    </div>

    <div class="md-layout pricing-rule">
      <channel-select multiple v-model="value.channel_ids" :online="true"></channel-select>
    </div>

    <!--div class="md-layout pricing-rule">
      <span>When % Occ</span>
      <numeric-comparator
        v-model="
          value.condition.pricing_occupancy_condition.comparison_operator
        "
      ></numeric-comparator>
      <md-field class="md-layout-item md-size-10 md-small-size-50">
        <label>value</label>
        <md-input
          v-model.number="value.condition.pricing_occupancy_condition.delta"
        ></md-input>
      </md-field>
      <md-radio
        v-model="value.condition.pricing_occupancy_condition.percent"
        :value="false"
        >Rooms</md-radio
      >
      <md-radio
        v-model="value.condition.pricing_occupancy_condition.percent"
        :value="true"
        >%</md-radio
      >
    </div-->
  </div>
</template>

<script>
import BoardSelect from '../../Inputs/BoardSelect.vue'
import ChannelSelect from '../../Inputs/ChannelSelect.vue'
import Currency from '@/utils/Currency'

let currency

export default {
  name: 'BoardPricingRule',
  components: { BoardSelect, ChannelSelect },
  props: {
    value: Object,
  },
  created() {
    this.currency = Currency[sessionStorage.getItem('currency')]
  },
}
</script>
